import { render, staticRenderFns } from "./BBrandModal.vue?vue&type=template&id=f928a978&scoped=true&"
import script from "./BBrandModal.vue?vue&type=script&lang=js&"
export * from "./BBrandModal.vue?vue&type=script&lang=js&"
import style0 from "./BBrandModal.vue?vue&type=style&index=0&id=f928a978&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f928a978",
  null
  
)

export default component.exports